import React, { useState, useEffect, useRef, Children } from "react"
import '../../assets/css/views/learning/courses.css'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, Button, Table, TableData, TableColumns, TablePreferences, TableColumnWidth, SelectOption, SelectInterface, ContextualMenu, IconPencil, IconTrash, Modal, ButtonGroup, IconWarningAlt, OptionInterface, TextBox, IconPlus, IconMinus, IconRemoteControl, DatePicker, Tabs, List, ListItem, IconReload, Checkbox, Accordion, AccordionItemInterface, IconX, IconCheckmark, AccordionInterface, IconCheckmarkCircle, Card, CustomImage, ProgressIndicator, RadioButtons, RadioButton } from "@veneer/core";

import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import courseService from "../../services/trainingApi/course.service";
import { ICourseContentDto, ICourseDto } from "../../models/dto/trainingApi/ICourseDto";
import ImageService from "../../services/generalApi/image.service";
import { IQuestionDto } from "../../models/dto/trainingApi/IQuestionDto";
import { IAnswerCourseIn, IEvaluationCourseIn } from "../../models/input/trainingApi/IEvaluationCourseIn";
import { decryptText, encryptText } from "../../utils/encryptionUtils";
import { Data } from "@react-google-maps/api";
import { sanitizeUrl } from "../../utils/sanitizeText";
import LoaderModal from "../../components/Loader/loaderModal";


export default function Courses() {

    const params = useParams();
    const [t] = useTranslation("global");
    const languageId: any = useSelector((state: RootState) => state.languageId);
    const state: any = useSelector((state: RootState) => state.user);
    type SelectValue = number | string | boolean; //CHECK

    const [loading, setLoading] = useState(false);

    //Tab
    const [selectedCourseTab, setSelectedCourseTab] = useState<number>(0);

    //Data
    const [coursesData, setCoursesData] = useState<ICourseDto[]>([]);
    const imageCache = useRef<Record<string, string>>({});
    const [blobImages, setBlobImages] = useState<{ id: number, url: string }[]>([]);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [actualCourse, setActualCourse] = useState<ICourseContentDto>();
    const [questions, setQuestions] = useState<IQuestionDto[]>([]);
    const [timeRepeat, setTimeRepeat] = useState<number>(NaN);
    const [certificate, setCertificate] = useState<string>('');
    const [score, setScore] = useState<string>('');



    const [available, setAvailable] = useState<ICourseDto[]>([]);
    const [availableFiltered, setAvailableFiltered] = useState<ICourseDto[]>([]);
    const [inProgress, setInProgress] = useState<ICourseDto[]>([]);
    const [inProgressFiltered, setInProgressFiltered] = useState<ICourseDto[]>([]);
    const [completed, setCompleted] = useState<ICourseDto[]>([]);
    const [completedFiltered, setCompletedFiltered] = useState<ICourseDto[]>([]);

    const [searchAvailable, setSearchAvailable] = useState<string>('');
    const [searchInProgress, setSearchInProgress] = useState<string>('');
    const [searchCompleted, setSearchCompleted] = useState<string>('');



    //shows
    const [showModalCourseAvailable, setShowModalCourseAvailable] = useState(false);
    const [showModalValidation, setShowModalValidation] = useState(false);
    const [showModalEvaluation, setShowModalEvaluation] = useState(false);
    const [showModalExitValidation, setShowModalExitValidation] = useState(false);
    const [showModalCourseApproved, setShowModalCourseApproved] = useState(false);
    const [showModalFailedCourse, setShowModalFailedCourse] = useState(false);
    const [showModalTimeFailedCourse, setShowModalTimeFailedCourse] = useState(false);
    const [showModalEvaluationCanceled, setShowModalEvaluationCanceled] = useState(false);






    //disbales
    const [buttonStartEvaluation, setButtonStartEvaluation] = useState(true);
    const [buttonEvaluate, setButtonEvaluate] = useState(true);



    const [time, setTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);

    const minutes = Math.floor((time % 360000) / 6000);
    const seconds = Math.floor((time % 6000) / 100);


    document.addEventListener("visibilitychange", () => {
        if (showModalEvaluation) {
            if (document.visibilityState === "hidden") {
                onExitEvaluation()
            }
        }
    });

    document.addEventListener('keyup', (e) => {
        if (showModalEvaluation) {
            if (e.key == 'PrintScreen') {
                onExitEvaluation()

            }
        }
    });




    useEffect(() => {
        getCoursesData()
    }, []);

    const getCoursesData = () => {
        courseService.getCoursesData()
            .then(r => {
                fillData(r)
            })
    }

    const loadImages = async () => {
        const promises = coursesData.map(async (course) => {
            if (imageCache.current[course.coverImage]) {
                return { id: course.courseID, url: imageCache.current[course.coverImage] };
            }
    
            try {
                const response = await ImageService.getBlobImage(course.coverImage);
                if (response instanceof Blob) {
                    const objectUrl = URL.createObjectURL(response);
                    imageCache.current[course.coverImage] = objectUrl;
                    return { id: course.courseID, url: objectUrl };
                }
            } catch (error) {
                console.error(`Error loading image for course ID ${course.courseID}:`, error);
            }
            return null;
        });
    
        const results = await Promise.all(promises);
        const filteredResults = results.filter((result): result is { id: number, url: string } => result !== null);
    
        setBlobImages(filteredResults);
        setImagesLoaded(true);
    };
    
    useEffect(() => {
        if (coursesData.length > 0) {
            loadImages();
        }
    }, [coursesData]);


    useEffect(() => {
        let intervalId: any;
        if (isRunning) {
            intervalId = setInterval(() => setTime(time + 100), 1000);
        }
        return () => clearInterval(intervalId);
    }, [isRunning, time]);


    useEffect(() => {
        if (questions.some(item => item.answerSelected === "")) {
            setButtonEvaluate(true)
        } else {
            setButtonEvaluate(false)
        }

    }, [questions]);

    useEffect(() => {
        let intervalIdRepeat: any;
        if (showModalTimeFailedCourse) {
            intervalIdRepeat = setInterval(() => setTimeRepeat(timeRepeat - 1), 1000);
        }
        return () => clearInterval(intervalIdRepeat)
    }, [timeRepeat]);

    const getUrlFromBlob = (courseId: number) => {
        const course = blobImages.find(x => x.id === courseId);
        return course ? course.url : "";
    };

    const formatDate = (date: string) => {
        let timestamp = Date.parse(date);
        if (isNaN(timestamp) === false) {
            let dateTemp = new Date(date);
            return dateTemp.toLocaleDateString('en-GB').split('/').join('/');
        } else {
            return ""
        }
    }

    const fillData = (data: ICourseDto[]) => {
        let courseDataTemp: ICourseDto[] = [];
        let availableTemp: ICourseDto[] = [];
        let inProgressTemp: ICourseDto[] = [];
        let completedTemp: ICourseDto[] = [];


        for (let i = 0; i < data.length; i++) {
            let course: ICourseDto = {
                courseID: data[i].courseID,
                courseName: data[i].courseName,
                description: data[i].description,
                startDate: data[i].startDate,
                endDate: data[i].endDate,
                coverImage: data[i].coverImage,
                statusByUser: data[i].statusByUser,
            }
            courseDataTemp.push(course);
            if (data[i].statusByUser === 1) {
                availableTemp.push(course)
            } else if (data[i].statusByUser === 2 || data[i].statusByUser === 4) {
                inProgressTemp.push(course)
            } else if (data[i].statusByUser === 3) {
                completedTemp.push(course)
            }
        }
        setCoursesData(courseDataTemp);
        setAvailable(availableTemp);
        setAvailableFiltered(availableTemp);
        setInProgress(inProgressTemp);
        setInProgressFiltered(inProgressTemp);
        setCompleted(completedTemp);
        setCompletedFiltered(completedTemp);

    }

    const openModalCourse = (courseId: number) => {
        courseService.getCourseContent(courseId)
            .then((r: ICourseContentDto) => {
                let courseTemp: ICourseContentDto = {
                    "courseID": r.courseID,
                    "courseName": r.courseName,
                    "url": encryptText(r.url),
                    "contentType": r.contentType
                }
                setActualCourse(courseTemp);
            }).finally(() => {
                setShowModalCourseAvailable(true)
                setTimeout(() => { setButtonStartEvaluation(false) }, 60000)
            })

    }

    const onOpenModalCertificate = (courseId: number) => {
        setShowModalCourseAvailable(false);
        setLoading(true);
        courseService.getCourseCertificate(courseId, languageId.value)
            .then(r => {
                setCertificate(encryptText(r));
            }).finally(() => {
                setLoading(false);
                setShowModalCourseApproved(true);
            })
    }


    const onCloseModalCourse = () => {
        setShowModalCourseAvailable(false)
        setButtonStartEvaluation(true)
        onResetData()
    }

    const onValidateStartEvaluation = (courseId: number) => {
        courseService.getEvaluationTimeRepeat(courseId)
            .then(r => {
                if (r != 0) {
                    setTimeRepeat(r)
                    setShowModalTimeFailedCourse(true)

                } else {
                    courseService.getEvaluationQuestion(courseId)
                        .then(r => {
                            fillQuestions(r)
                        }).finally(() => {
                            setShowModalCourseAvailable(false)
                            setButtonStartEvaluation(true)
                            setTimeout(() => { setShowModalValidation(true) }, 300)

                        })

                }

            })


    }

    const fillQuestions = (data: IQuestionDto[]) => {
        let questionsTemp: IQuestionDto[] = [];
        for (let i = 0; i < data.length; i++) {
            let question: IQuestionDto = {

                evaluationQuestionID: data[i].evaluationQuestionID,
                questionTypeID: data[i].questionTypeID,
                question: data[i].question,
                hint: data[i].hint,
                options: data[i].options,
                answerSelected: ""
            }
            questionsTemp.push(question)
        }
        setQuestions(questionsTemp)

    }

    const onResetData = () => {
        setCoursesData([]);
        setAvailable([]);
        setAvailableFiltered([]);
        setInProgress([]);
        setInProgressFiltered([]);
        setCompleted([]);
        setCompletedFiltered([]);
        getCoursesData();
        setIsRunning(false);
        setTime(0);

    }

    const onStartEvaluation = () => {
        setShowModalValidation(false)
        setTimeout(() => {
            setShowModalEvaluation(true)
            setIsRunning(true)
        }, 300)

    }

    const onExitEvaluation = () => {
        setShowModalExitValidation(false)
        setTimeout(() => { setShowModalEvaluation(false) }, 200);
        onLoseEvaluation()
    }

    const onCloseModalValidation = () => {
        setShowModalValidation(false)
        onResetData()
    }

    const onCloseModalFailedCourse = () => {
        setShowModalFailedCourse(false)
        onResetData()
    }




    const handleChangeAnswers = (event: any, questionId: number) => {
        const questionsTemp = questions;
        const question = questionsTemp.find(item => item.evaluationQuestionID === questionId);
        if (question) {
            question.answerSelected = event.target.value;
            setQuestions([...questionsTemp])
        }

    }

    const handleChangeSelectEvaluation = (event: any, optionID: number, questionId: number) => {
        const questionsTemp = questions;
        const question = questionsTemp.find(item => item.evaluationQuestionID === questionId);
        if (question) {
            if (question.answerSelected) {
                let arrayTemp = question.answerSelected.split(',');
                if (arrayTemp.some(item => item.substring(0, 3) === String(optionID))) {
                    let item = arrayTemp.find(item => item.substring(0, 3) === String(optionID))
                    let index = arrayTemp.indexOf(item!);
                    arrayTemp.splice(index);
                    arrayTemp.push(`${optionID}-${event.value}`);
                    question.answerSelected = arrayTemp.toString();

                } else {
                    arrayTemp.push(`${optionID}-${event.value}`);
                    question.answerSelected = arrayTemp.toString();
                }
            } else {
                question.answerSelected = `${optionID}-${event.value}`;
            }
            setQuestions([...questionsTemp])
        }


    }

    const handleChangeCheckbox = (event: any, questionId: number) => {
        const questionsTemp = questions;
        const question = questionsTemp.find(item => item.evaluationQuestionID === questionId);
        if (question) {
            if (question.answerSelected) {
                let arrayTemp = question.answerSelected.split(',');
                if (arrayTemp.includes(event.target.value)) {
                    let index = arrayTemp.indexOf(event.target.value);
                    arrayTemp.splice(index);
                    question.answerSelected = arrayTemp.toString();
                } else {
                    arrayTemp.push(event.target.value);
                    question.answerSelected = arrayTemp.toString();
                }
            } else {
                question.answerSelected = event.target.value;
            }
            setQuestions([...questionsTemp])
        }
    }



    const onEvaluate = () => {

        let answers: IAnswerCourseIn[] = [];
        for (let i = 0; i < questions.length; i++) {
            if (questions[i].questionTypeID === 2 || questions[i].questionTypeID === 4) {
                answers.push({
                    QuestionID: questions[i].evaluationQuestionID,
                    QuestionType: questions[i].questionTypeID,
                    AnswerID: [questions[i].answerSelected?.slice(6)!]
                })

            } else if (questions[i].questionTypeID === 3) {
                answers.push({
                    QuestionID: questions[i].evaluationQuestionID,
                    QuestionType: questions[i].questionTypeID,
                    AnswerID: questions[i].answerSelected!.split(',')
                })
            } else {
                answers.push({
                    QuestionID: questions[i].evaluationQuestionID,
                    QuestionType: questions[i].questionTypeID,
                    AnswerID: [questions[i].answerSelected!]
                })

            }
        }
        let answersIn: IEvaluationCourseIn = {
            CourseID: actualCourse?.courseID!,
            Answer: answers

        }
        courseService.getCourseEvaluationResult(answersIn)
            .then(r => {
                setScore(r.evaluationResult)
                if (r.courseApproved === 0) {
                    setShowModalFailedCourse(true)
                } else if (r.courseApproved === 1) {
                    setShowModalCourseApproved(true)
                }
                setShowModalEvaluation(false);
            })

    }

    const onLoseEvaluation = () => {

        let badAnswer: IAnswerCourseIn[] = [
            {
                QuestionID: 0,
                QuestionType: 0,
                AnswerID: ["0"]
            }
        ]

        let badAnswerIn: IEvaluationCourseIn = {
            CourseID: actualCourse?.courseID!,
            Answer: badAnswer

        }
        courseService.getCourseEvaluationResult(badAnswerIn)
            .then(r => {
                onResetData();
                setShowModalEvaluation(false);
                setShowModalEvaluationCanceled(true);
            })
    }

    const handleChangeSearchAvailable = (value: string) => {
        setSearchAvailable(value);
        const filterArray = available.filter((element) => {
            if (element.courseName.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setAvailableFiltered(filterArray)
    }

    const handleChangeSearchInProgress = (value: string) => {
        setSearchInProgress(value);
        const filterArray = inProgress.filter((element) => {
            if (element.courseName.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setInProgressFiltered(filterArray)
    }

    const handleChangeSearchCompleted = (value: string) => {
        setSearchCompleted(value);
        const filterArray = completed.filter((element) => {
            if (element.courseName.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setCompletedFiltered(filterArray)
    }





    return (
        <>
            {loading && <LoaderModal />}
            <div className="coursesDiv">
                <Tabs
                    className="coursesTabs"
                    controlId="coursesTabs"
                    mode="contained"
                    onChangeTab={setSelectedCourseTab}
                    selectedTabId={selectedCourseTab}
                    tabs={[
                        {
                            id: 0, label: t("header.availables"), content:
                                <>
                                    <TextBox
                                        id="searchCourses"
                                        className="searchCourses"
                                        label={t("header.search")}
                                        type="search"
                                        onChange={handleChangeSearchAvailable}
                                        value={searchAvailable}
                                    />
                                    <Card
                                        appearance="outlined"
                                        className="coursesCard"
                                        content={
                                            <div>
                                                {
                                                    availableFiltered.length > 0 ?
                                                        availableFiltered.map((course, index) =>
                                                            <Card
                                                                key={'card' + index}
                                                                appearance="outlined"
                                                                className="coursesCards"
                                                                onClick={() => openModalCourse(course.courseID)}
                                                                content={
                                                                    <div className="coursesContentCards">
                                                                        <div className="coursesContentCardsImageDiv">
                                                                            {
                                                                                imagesLoaded ? <CustomImage size={180} className="coursesContentCardsImage"
                                                                                    src={getUrlFromBlob(course.courseID)}
                                                                                /> : <ProgressIndicator
                                                                                    appearance="circular"
                                                                                    behavior="indeterminate"
                                                                                />
                                                                            }
                                                                        </div>
                                                                        <div>
                                                                            <h6>{course.courseName}</h6>
                                                                            <br />
                                                                            <p>{course.description}</p>
                                                                            <br />
                                                                            {course.endDate && String(course.endDate) !== '' && String(course.endDate) !== '0001-01-01T00:00:00' ?
                                                                                <p>{t('header.endsOn')}:  {formatDate(String(course.endDate))} </p>
                                                                                : null}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            />
                                                        )

                                                        : <div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItemsOutTable" /></div>{t("header.noCoursesFound")}</div>

                                                }
                                            </div>
                                        }
                                    />
                                </>
                        },
                        {
                            id: 1, label: t("header.inProgress"), content:
                                <>
                                    <TextBox
                                        id="searchCourses"
                                        className="searchCourses"
                                        label={t("header.search")}
                                        type="search"
                                        onChange={handleChangeSearchInProgress}
                                        value={searchInProgress}
                                    />
                                    <Card
                                        appearance="outlined"
                                        className="coursesCard"
                                        content={
                                            <div>
                                                {
                                                    inProgressFiltered.length > 0 ?
                                                        inProgressFiltered.map((course, index) =>
                                                            <Card
                                                                key={'course' + index}
                                                                appearance="outlined"
                                                                className="coursesCards"
                                                                onClick={() => openModalCourse(course.courseID)}
                                                                content={
                                                                    <div className="coursesContentCards">
                                                                        <div className="coursesContentCardsImageDiv">
                                                                            {
                                                                                imagesLoaded ? <CustomImage size={180} className="coursesContentCardsImage"
                                                                                    src={getUrlFromBlob(course.courseID)}
                                                                                /> : <ProgressIndicator
                                                                                    appearance="circular"
                                                                                    behavior="indeterminate"
                                                                                />
                                                                            }
                                                                        </div>
                                                                        <div>
                                                                            <h6>{course.courseName}</h6>
                                                                            <br />
                                                                            <p>{course.description}</p>
                                                                            <br />
                                                                            {course.endDate && String(course.endDate) !== '' && String(course.endDate) !== '0001-01-01T00:00:00' ?
                                                                                <p>{t('header.endsOn')}:  {formatDate(String(course.endDate))} </p>
                                                                                : null}</div>
                                                                    </div>
                                                                }
                                                            />
                                                        )

                                                        : <div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItemsOutTable" /></div>{t("header.noCoursesFound")}</div>

                                                }
                                            </div>
                                        }
                                    />
                                </>
                        },
                        {
                            id: 2, label: t("header.completed"), content:
                                <>
                                    <TextBox
                                        id="searchCourses"
                                        className="searchCourses"
                                        label={t("header.search")}
                                        type="search"
                                        onChange={handleChangeSearchCompleted}
                                        value={searchCompleted}
                                    />
                                    <Card
                                        appearance="outlined"
                                        className="coursesCard"
                                        content={
                                            <div>
                                                {
                                                    completedFiltered.length > 0 ?
                                                        completedFiltered.map((course, index) =>
                                                            <Card
                                                                key={'completed' + index}
                                                                appearance="outlined"
                                                                className="coursesCards"
                                                                onClick={() => openModalCourse(course.courseID)}
                                                                content={
                                                                    <div className="coursesContentCards">
                                                                        <div className="coursesContentCardsImageDiv">
                                                                            {
                                                                                imagesLoaded ? <CustomImage size={180} className="coursesContentCardsImage"
                                                                                    src={getUrlFromBlob(course.courseID)}
                                                                                /> : <ProgressIndicator
                                                                                    appearance="circular"
                                                                                    behavior="indeterminate"
                                                                                />
                                                                            }
                                                                        </div>
                                                                        <div>
                                                                            <h6>{course.courseName}</h6>
                                                                            <br />
                                                                            <p>{course.description}</p>
                                                                            <br />
                                                                            {course.endDate && String(course.endDate) !== '' && String(course.endDate) !== '0001-01-01T00:00:00' ?
                                                                                <p>{t('header.endsOn')}:  {formatDate(String(course.endDate))} </p>
                                                                                : null}</div>
                                                                    </div>
                                                                }
                                                            />
                                                        )

                                                        : <div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItemsOutTable" /></div>{t("header.noCoursesFound")}</div>

                                                }
                                            </div>
                                        }
                                    />
                                </>
                        },

                    ]}
                    type="online"
                />
            </div>


            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalCourseAvailable"
                    closeButton={true}
                    align="center"
                    id="modalCourseAvailable"
                    show={showModalCourseAvailable}
                    onClose={() => onCloseModalCourse()}
                    title={actualCourse?.courseName}
                >
                    <div className="modalCourseAvailableDiv">
                        <iframe src={sanitizeUrl(decryptText(actualCourse?.url!))} className="modalCourseAvailableIFrame" />
                        {
                            selectedCourseTab === 2 ?
                                <Button onClick={() => onOpenModalCertificate(actualCourse?.courseID!)}>{t("header.certificate")}</Button>
                                :
                                <Button disabled={buttonStartEvaluation} onClick={() => onValidateStartEvaluation(actualCourse?.courseID!)}>{t("header.startEvaluation")}</Button>
                        }
                    </div>


                </Modal>
            </div>

            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalValidation"
                    closeButton={true}
                    align="center"
                    id="modalValidation"
                    show={showModalValidation}
                    onClose={() => onCloseModalValidation()}
                    footer={(
                        <ButtonGroup className="validationTestButtonGroup">
                            <Button onClick={() => onStartEvaluation()}>{t("header.startEvaluation")}</Button>
                            <Button onClick={() => onCloseModalValidation()} appearance="secondary">{t("header.cancel")}</Button>
                        </ButtonGroup>
                    )}
                    title={t("header.evaluation") + " " + actualCourse?.courseName}
                >
                    <IconWarningAlt size={120} />
                    <br />
                    <b>{t("header.evaluationAlert")}</b>
                </Modal>
            </div>


            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalEvaluation"
                    closeButton={true}
                    align="center"
                    id="modalEvaluation"
                    show={showModalEvaluation}
                    onClose={() => setShowModalExitValidation(true)}
                    footer={(
                        <Button disabled={buttonEvaluate} onClick={() => onEvaluate()}>{t("header.evaluate")}</Button>
                    )}
                    title={t("header.evaluation")}
                >
                    <div>
                        <p className="stopwatch-time">
                            {minutes.toString().padStart(2, "0")}:{seconds.toString().padStart(2, "0")}
                        </p>
                        <div className="modalEvaluationQuestions">

                            {questions.map((question, index) => {
                                return <Card
                                    key={'question' + index}
                                    appearance="outlined"
                                    className="modalEvaluationCard"
                                    content={
                                        <div className="modalEvaluationQuestion">
                                            <h6>{index + 1 + ". "}{question.question}</h6>
                                            <br />
                                            {
                                                {
                                                    1:
                                                        JSON.parse(question.options).map((option: any) => {
                                                            return <Checkbox id={"checkbox" + option.OptionID} label={option.Option} onClick={(e) => handleChangeCheckbox(e, question.evaluationQuestionID)} />
                                                        })
                                                    ,
                                                    2: <RadioButtons alignment="vertical" name={"radio" + question.evaluationQuestionID} value={question.answerSelected}>
                                                        {JSON.parse(question.options).map((option: any) => {
                                                            return <RadioButton id={"radio" + option.OptionID} value={"option" + option.OptionID} label={option.Option} onClick={(e) => handleChangeAnswers(e, question.evaluationQuestionID)} />
                                                        })}
                                                    </RadioButtons>,

                                                    3: JSON.parse(question.options).filter((item: { Column: number; }) => item.Column === 2).map((option: any, index: number) => {
                                                        return <Select
                                                            key={'select' + index}
                                                            className="modalEvaluationSelect"
                                                            label={option.Option}
                                                            onChange={e => handleChangeSelectEvaluation(e, option.OptionID, question.evaluationQuestionID)}
                                                            options={JSON.parse(question.options).filter((item: { Column: number; }) => item.Column === 1).map((option: any) => {
                                                                return {
                                                                    'value': option.OptionID,
                                                                    'label': option.Option,
                                                                }
                                                            })}
                                                            placement="bottom-start"
                                                        />

                                                    }),
                                                    4: <RadioButtons alignment="vertical" name={"radio" + question.evaluationQuestionID} value={question.answerSelected}>
                                                        {JSON.parse(question.options).map((option: any) => {
                                                            return <RadioButton id={"radio" + option.OptionID} value={"option" + option.OptionID} label={option.Option} onClick={(e) => handleChangeAnswers(e, question.evaluationQuestionID)} />
                                                        })}
                                                    </RadioButtons>
                                                }[question.questionTypeID]
                                            }

                                        </div>
                                    }
                                />
                            })}
                        </div>


                    </div>


                </Modal>
            </div>

            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalExitValidation"
                    align="center"
                    id="modalExitValidation"
                    show={showModalExitValidation}
                    footer={(
                        <ButtonGroup className="validationTestButtonGroup">
                            <Button onClick={() => onExitEvaluation()}>{t("header.yes")}</Button>
                            <Button onClick={() => setShowModalExitValidation(false)} appearance="secondary">{t("header.cancel")}</Button>
                        </ButtonGroup>
                    )}
                    title={t("modal.warningTitle")}
                >
                    <IconWarningAlt size={120} />
                    <br />
                    <b>{t("header.exitAlert")}</b>
                </Modal>
            </div>

            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalCourseApproved"
                    align="center"
                    id="modalCourseApproved"
                    show={showModalCourseApproved}
                    onClose={() => setShowModalCourseApproved(false)}
                    footer={(
                        <Button onClick={() => setShowModalCourseApproved(false)} appearance="primary">{t("header.closebutton")}</Button>

                    )}
                    title={t("header.courseApproved")}
                >
                    <div className="modalCourseApprovedDiv">
                        <img className="modalCourseApprovedImage" src={`data:image/jpeg;base64, ${sanitizeUrl(decryptText(certificate))}`} />
                    </div>


                </Modal>
            </div>


            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalFailedCourse"
                    align="center"
                    id="modalFailedCourse"
                    show={showModalFailedCourse}
                    onClose={() => onCloseModalFailedCourse()}
                    footer={(
                        <Button onClick={() => onCloseModalFailedCourse()} appearance="primary">{t("header.closebutton")}</Button>
                    )}
                    title={t("header.failedCourse")}
                >
                    <IconWarningAlt size={120} />
                    <br />
                    <p>{t("header.score")}:{" " + score}%</p>
                    <b>{t("header.alertFailedCourse")}</b>
                </Modal>
            </div>


            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalTimeFailedCourse"
                    align="center"
                    id="modalTimeFailedCourse"
                    show={showModalTimeFailedCourse}
                    onClose={() => setShowModalTimeFailedCourse(false)}
                    footer={(
                        <Button onClick={() => setShowModalTimeFailedCourse(false)} appearance="primary">{t("header.closebutton")}</Button>
                    )}
                    title={actualCourse?.courseName}
                >
                    <IconWarningAlt size={120} />
                    <br />
                    <b>{t("header.alertTimeFailedCourse")}</b>
                    <br />
                    <div className="modalTimeTextboxs">

                        <TextBox
                            id="modalTimeTextbox"
                            className="modalTimeTextbox"
                            label="D"
                            value={String(Math.floor(timeRepeat / 86400))}
                            readOnly
                        />
                        <TextBox
                            id="modalTimeTextbox"
                            className="modalTimeTextbox"
                            label="H"
                            value={String(Math.floor((timeRepeat % 86400) / 3600))}
                            readOnly
                        />
                        <TextBox
                            id="modalTimeTextbox"
                            className="modalTimeTextbox"
                            label="M"
                            value={String(Math.floor(((timeRepeat % 86400) % 3600) / 60))}
                            readOnly
                        />
                        <TextBox
                            id="modalTimeTextbox"
                            className="modalTimeTextbox"
                            label="S"
                            value={String(((timeRepeat % 86400) % 3600) % 60)}
                            readOnly
                        />

                    </div>


                </Modal>
            </div>

            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalEvaluationCanceled"
                    align="center"
                    id="modalEvaluationCanceled"
                    show={showModalEvaluationCanceled}
                    onClose={() => setShowModalEvaluationCanceled(false)}
                    footer={(
                        <Button onClick={() => setShowModalEvaluationCanceled(false)} appearance="primary">{t("header.closebutton")}</Button>

                    )}
                    title={t("header.evaluationCanceled")}
                >
                    <IconWarningAlt size={120} />
                    <br />
                    <b>{t("header.evaluationCaneledMessage")}</b>


                </Modal>
            </div>



        </>


    );
}